import React from 'react';
import { useParams } from 'react-router-dom';
import { Link, Text } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { Container } from 'styles';
import { useAdvocacyContext } from 'contexts/advocacy';

const getCopy = copyFor('advocacy.message.address');

export const Address = () => {
  const { typedAddress } = useAdvocacyContext();
  const { utilityAccountId } = useParams<{ utilityAccountId?: string }>();

  return (
    <Container>
      <Text textStyle="heading500" margin={{ bottom: '16px' }} tag="h2">
        {getCopy('title')}
      </Text>
      <Container flex direction="column" width="100%">
        <Text textStyle="paragraph400">{typedAddress}</Text>
        <Text textStyle="paragraph400">
          <Link type="inline" to={routes({ utilityAccountId }).advocacyAddress}>
            {getCopy('link')}
          </Link>
        </Text>
      </Container>
    </Container>
  );
};
